// extracted by mini-css-extract-plugin
export default {"link":"BrokenLinksCenter_link__aD3W2","copyIcon":"BrokenLinksCenter_copyIcon__kOaf0"};